import React from 'react';
import { AuthConsumer } from 'components/Auth/authContext';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Avatar from '@material-ui/core/Avatar';
import Grid from '@material-ui/core/Grid';
import Box from '@material-ui/core/Box';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import EmailIcon from 'assets/img/icons/email.svg';
import CallIcon from 'assets/img/icons/call.svg';
import LockIcon from 'assets/img/icons/lock.svg';
import LogoutIcon from 'assets/img/icons/logout.svg';
import { translate } from 'components/Translation';
import { ClassNameMap } from '@material-ui/core/styles/withStyles';
import { convertNameToAvatar } from 'utils/converters/convertNameToAvatar';
import { getUserDropdownLabels } from 'redux/modules/dynamicLabels/selectors';
import { useSelector } from 'react-redux';
import { DescriptionM, DescriptionS } from 'components/Typography/Typography';
import CanPerform from 'components/CanPerform/CanPerform';

type ProfileDetailsContentProps = {
	classes: ClassNameMap<any>;
	showChangeEmail: () => void;
	showChangeNumber: () => void;
	showChangePassword: () => void;
};

const ProfileDetailsContent = ({
	classes,
	showChangeEmail,
	showChangeNumber,
	showChangePassword,
}: ProfileDetailsContentProps) => {
	const userDropdownLabels = useSelector(getUserDropdownLabels);

	return (
		<AuthConsumer>
			{({ logout, user }) => (
				<>
					<Card elevation={3} className={classes.profileCard}>
						<CardContent className={classes.cardContent}>
							<Box p={0} className={classes.avatarContainer}>
								<Grid container alignItems="center" spacing={2}>
									<Grid item xs={12} sm="auto">
										<Avatar className={classes.avatar}>
											<span aria-hidden={true}>{convertNameToAvatar(user.userName)}</span>
										</Avatar>
									</Grid>
									<Grid item xs={12} sm>
										<DescriptionM customClassName={classes.userInfo}>{user.email}</DescriptionM>
										<DescriptionS customClassName={classes.userType} disableMargin>
											{user.userType}
										</DescriptionS>
										<DescriptionS customClassName={classes.userType} disableMargin>
											{user.contactNumber1}
										</DescriptionS>
									</Grid>
								</Grid>
							</Box>
							<List component="nav" role="menu">
								<CanPerform
									action="profile:change_email"
									yes={
										<>
											<ListItem
												button
												className={classes.actions}
												onClick={showChangeEmail}
												role="menuitem"
											>
												<ListItemIcon>
													<img src={EmailIcon} role="presentation" alt="" />
												</ListItemIcon>
												<ListItemText primary={userDropdownLabels?.editemail} />
											</ListItem>
										</>
									}
								/>
								<CanPerform
									action="profile:change_number"
									yes={
										<>
											<ListItem
												button
												className={classes.actions}
												onClick={showChangeNumber}
												role="menuitem"
											>
												<ListItemIcon>
													<img src={CallIcon} role="presentation" alt="" />
												</ListItemIcon>
												<ListItemText primary={userDropdownLabels?.editnumber} />
											</ListItem>
										</>
									}
								/>
								<CanPerform
									action="profile:change_password"
									yes={
										<ListItem
											button
											className={classes.actions}
											onClick={showChangePassword}
											role="menuitem"
										>
											<ListItemIcon>
												<img src={LockIcon} role="presentation" alt="" />
											</ListItemIcon>
											<ListItemText primary={userDropdownLabels?.changepassword} />
										</ListItem>
									}
								/>
								<ListItem
									button
									className={classes.actions}
									onClick={logout}
									data-testid="logout-action"
									role="menuitem"
								>
									<ListItemIcon>
										<img src={LogoutIcon} role="presentation" alt="" />
									</ListItemIcon>
									<ListItemText primary={translate('navbar.log.out')} />
								</ListItem>
							</List>
						</CardContent>
					</Card>
				</>
			)}
		</AuthConsumer>
	);
};

export default ProfileDetailsContent;
